import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { PressControlComponent } from 'design/pressControl';
import { TextComponent } from 'design/text/textComponents';
import { ThemeProviderComponent } from 'design/themeProvider';
import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { FinishScreenLayout } from 'design/finishScreenLayout/finishScreenLayout';

import { ReactComponent as Logo } from 'svg/stack-manager-finish-logo.svg';

type Props = {
  onNext: () => void;
};

export const ProdStackManagerFinishIntermediate = (props: Props) => {
  const { onNext } = props;

  const {
    prodStackManager: { finishIntermediate: ownDictionary },
  } = useIntlDictionary();

  return (
    <ThemeProviderComponent mode="prodRegistraionComplete">
      <CenteredLayoutComponent>
        <FinishScreenLayout
          top={<Logo />}
          middle={
            <TextComponent size={'m'}>{ownDictionary.titleText}</TextComponent>
          }
          bottom={
            <PressControlComponent
              theme="accent"
              type="button"
              onPress={onNext}
            >
              {ownDictionary.actionText}
            </PressControlComponent>
          }
        />
      </CenteredLayoutComponent>
    </ThemeProviderComponent>
  );
};
